import { useGetAlarm } from '@akin-home/alarms/react';
import { useGetAlert } from '@akin-home/alerts/react';
import { CalendarItemType } from '@akin-home/amplify';
import { useGetEvent } from '@akin-home/events/react';
import { useGetMeal } from '@akin-home/meals/react';
import { CalendarItemUnion } from '../types';

interface Props {
  id: string;
  type: CalendarItemType;
  recurrence_id?: string;
}

interface Result<T = CalendarItemUnion> {
  item?: T;
  origin?: T;
  isLoading: boolean;
}

export const useGetCalendarItem = <T extends CalendarItemUnion>(
  props: Props
): Result<T> => {
  const { id, type } = props;

  const event_result = useGetEvent(id, {
    enabled: type === CalendarItemType.Event,
  });

  const alarm_result = useGetAlarm(id, {
    enabled: type === CalendarItemType.Alarm,
  });

  const alert_result = useGetAlert(id, {
    enabled: type === CalendarItemType.Alert,
  });

  const meal_result = useGetMeal(
    { id },
    {
      enabled: type === CalendarItemType.Meal,
    }
  );

  if (type === CalendarItemType.Event) {
    return {
      item: event_result.item as T,
      isLoading: event_result.isLoading,
    };
  }

  if (type === CalendarItemType.Alarm) {
    return {
      item: alarm_result.item as T,
      isLoading: alarm_result.isLoading,
    };
  }

  if (type === CalendarItemType.Alert) {
    return {
      item: alert_result.item as T,
      isLoading: alert_result.isLoading,
    };
  }

  if (type === CalendarItemType.Meal) {
    return {
      item: meal_result.item as T,
      isLoading: meal_result.isLoading,
    };
  }

  return {
    item: undefined,
    origin: undefined,
    isLoading: false,
  };
};
